/* eslint-disable */
import * as Types from "./types";

import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type GqlMatterTypeFieldsFragment = {
  __typename: "MatterType";
  id: string;
  source: string;
  name: string;
  category: string;
  location: string;
  representativeOptions: Array<string>;
};

export const MatterTypeFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "matterTypeFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MatterType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "location" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "representativeOptions" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GqlMatterTypeFieldsFragment, unknown>;
